<script>
  import { slide } from "svelte/transition";
  import { link } from "svelte-spa-router";
  import config from "../stores/config";
  import * as ls from "local-storage";

  let menuVisible = false;

  let toggleMenu = () => {
    menuVisible = !menuVisible;
  };

  let hideMenu = () => {
    menuVisible = false;
  };

  const handleLogout = () => {
    ls.remove("jwt");
    window.location.reload();
  };
</script>

<div
  class="block lg:hidden px-4 pt-2 pb-1 rounded-md shadow-sm bg-brand-white relative"
  style="z-index:999;"
>
  <button class="focus:outline-none" on:click={toggleMenu}>
    <ion-icon name="menu-outline" class="text-3xl" />
  </button>

  {#if menuVisible}
    <div
      transition:slide={{ duration: 250 }}
      class={`absolute mt-12 top-0 right-0 w-56 flex flex-col px-3 pt-4 pb-2 rounded-md shadow-md bg-brand-white border-t-4 border-brand-weak-green`}
      style="transform: translateY(10px);"
    >
      <a class="mb-5" on:click={hideMenu} use:link href="/">Acceuil</a>
      <!-- <a class="mb-5" on:click={hideMenu} use:link href="/events">Dome Events</a
      > -->
      <!-- {#if $config.currentUser.role == "super-admin"}
        <a class="mb-5" on:click={hideMenu} use:link href="/admins">
          Administrators
        </a>
      {/if} -->
      <a class="mb-5" on:click={hideMenu} use:link href="/profile"> Profile </a>
      <a class="mb-5" on:click={hideMenu} use:link href="/employees">
        Employés
      </a>
      <button class="mb-5 btn btn-primary" on:click={handleLogout}>
        Logout
        <ion-icon name="log-out" class="ml-2 text-2xl" />
      </button>
    </div>
  {/if}
</div>
